import type { PetitionCommentsPageState } from './types';

export const INITIAL_STATE: PetitionCommentsPageState = {
	deleteConfirmMessage: false,
	deletedComments: [],
};
